import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { __t } from '@mssgme/shared';
import { urlSafeComponent } from '@mssgme/helpers';
import { LinkBlank } from '@mssgme/ui';
import styles from './styles.scss';

class ActionSheet extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        links: PropTypes.array.isRequired,
        cancel: PropTypes.func.isRequired,
        visible: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        visible: false,
    };

    render() {
        const { title, links, cancel } = this.props;

        return (
            <div className={styles.root}>
                <div className={styles.bg} onClick={cancel} />
                <div className={styles.content}>
                    <div className={styles.listContainer}>
                        <span className={styles.heading}>{title}</span>
                        <ul className={styles.linksList} id="card_list">
                            {links.map((el, index) => (
                                <li key={index}>
                                    <LinkBlank
                                        href={el.redirectUrl}
                                        target="_blank"
                                        data-id={el._id}
                                        data-title={el.title}
                                        data-element="custom-link"
                                        data-event-name={urlSafeComponent(el.url)}
                                    >
                                        {el.title}
                                    </LinkBlank>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <span className={styles.cancel} onClick={cancel}>
                        {__t('cancel')}
                    </span>
                </div>
            </div>
        );
    }
}

export default ActionSheet;
